import { RootState } from "../../rootReducer";

export const selectIsLoading = (state: RootState) =>
  state.departmentList4Dashboard.loading;
export const attendanceStatusErrorMessage = (state: RootState) =>
  state.departmentList4Dashboard.error;
export const departmentList4DashboardDataResponse = (state: RootState) =>
  state.departmentList4Dashboard.departmentList4DashboardResponse;
